export type FeaturedBonus = {
  id: string;
  icon: string;
  en_title: string;
  bm_title: string;
  en_label: string;
  bm_label: string;
  highlight: string;
  en_desc: string;
  bm_desc: string;
};

export const FEATURED_BONUSES: FeaturedBonus[] = [
  {
    id: 'new-member-register-free-rm88',
    icon: 'ri-user-add-line',
    en_title: 'New Member Register Free RM88',
    bm_title: 'Ahli Baharu Daftar Percuma RM88',
    en_label: 'New Member\nRegister Free',
    bm_label: 'Ahli Baharu\nDaftar Percuma',
    highlight: 'RM88',
    en_desc:
      'Register a new MrCuci account and receive RM88 free bonus credit — no deposit required. Limited to 1 claim per member ID. Playable on Semaut Event Game slots.',
    bm_desc:
      'Daftar akaun MrCuci baharu dan terima kredit bonus percuma RM88 — tiada deposit diperlukan. Terhad 1 tuntutan setiap ID ahli. Boleh dimainkan pada slot Semaut Event Game.',
  },
  {
    id: 'monthly-competition-deposit-ranking-rm1088',
    icon: 'ri-trophy-line',
    en_title: 'Monthly Competition Deposit Ranking RM1088',
    bm_title: 'Pertandingan Bulanan Kedudukan Deposit RM1088',
    en_label: 'Monthly Competition\nDeposit Ranking',
    bm_label: 'Pertandingan Bulanan\nKedudukan Deposit',
    highlight: 'RM1088',
    en_desc:
      'Runs from the 1st to the last day of each month. Ranking is based on total deposits — deposit more to climb higher. Top rank wins up to RM1,088 cash, settled after each month via Live Chat.',
    bm_desc:
      'Berlangsung dari 1hb hingga hari terakhir setiap bulan. Kedudukan dikira berdasarkan jumlah deposit — deposit lebih banyak untuk naik lebih tinggi. Kedudukan #1 menang sehingga RM1,088 tunai, diselesaikan selepas setiap bulan melalui Live Chat.',
  },
  {
    id: 'welcome-bonus-50',
    icon: 'ri-gift-2-line',
    en_title: 'Welcome Bonus 50%',
    bm_title: 'Bonus Selamat Datang 50%',
    en_label: 'Welcome Bonus',
    bm_label: 'Bonus Selamat Datang',
    highlight: '50%',
    en_desc:
      'New players receive a 50% bonus on their first deposit from RM1. One claim per member ID. Valid on all slots except excluded providers such as Jili, Lucky365, MicroGaming, RedTiger, Boongo, and In Out.',
    bm_desc:
      'Pemain baharu terima bonus 50% pada deposit pertama dari RM1. Satu tuntutan setiap ID ahli. Sah untuk semua slot kecuali pembekal terkecuali seperti Jili, Lucky365, MicroGaming, RedTiger, Boongo, dan In Out.',
  },
  {
    id: 'deposit-rm200-free-rm200',
    icon: 'ri-wallet-3-line',
    en_title: 'Deposit RM200 Free RM200',
    bm_title: 'Deposit RM200 Percuma RM200',
    en_label: 'Deposit RM200\nFree RM200',
    bm_label: 'Deposit RM200\nPercuma RM200',
    highlight: 'RM200',
    en_desc:
      'Deposit RM200 and receive RM200 free bonus. Claim when balance is below RM1, once per day, ×10 turnover, max withdraw RM200, no rollover. Fast deposit via local bank or e-wallet.',
    bm_desc:
      'Deposit RM200 dan terima bonus percuma RM200. Tuntut apabila baki bawah RM1, sekali sehari, turnover ×10, max cuci RM200, tiada rollover. Deposit pantas melalui bank tempatan atau e-dompet.',
  },
];

export const FEATURED_BONUS_SUMMARY_EN =
  'New Member Register Free RM88, Monthly Competition Deposit Ranking RM1088, Welcome Bonus 50%, and Deposit RM200 Free RM200';

export const FEATURED_BONUS_SUMMARY_BM =
  'Ahli Baharu Daftar Percuma RM88, Pertandingan Bulanan Kedudukan Deposit RM1088, Bonus Selamat Datang 50%, dan Deposit RM200 Percuma RM200';
